import api from '../services/api';

const API_ORIGIN = (api.defaults.baseURL || '').replace(/\/origin\/api\/?$/, '');

export function resolveImageUrl(imagePath) {
  if (!imagePath) return '';
  if (/^https?:\/\//i.test(imagePath) || imagePath.startsWith('data:')) return imagePath;
  return `${API_ORIGIN}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
}
